'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _LabelledInputComponent = require('../input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _SubSectionHeaderComponent = require('./SubSectionHeaderComponent');

var _SubSectionHeaderComponent2 = _interopRequireDefault(_SubSectionHeaderComponent);

var _DatePickerComponent = require('../input/DatePickerComponent');

var _DatePickerComponent2 = _interopRequireDefault(_DatePickerComponent);

var _SelectComponent = require('../input/SelectComponent');

var _SelectComponent2 = _interopRequireDefault(_SelectComponent);

var _TextInputComponent = require('../input/TextInputComponent');

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

var _CurrencyInputComponent = require('../input/CurrencyInputComponent');

var _CurrencyInputComponent2 = _interopRequireDefault(_CurrencyInputComponent);

var _PropTypes = require('../../validators/common/PropTypes');

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders a single additional dependent component for the form.
 */

var DependentComponent = function DependentComponent(_ref) {
  var formConfig = _ref.formConfig,
      dynamicFieldIndex = _ref.dynamicFieldIndex,
      inputComponentField = _ref.inputComponentField,
      onChangeHook = _ref.onChangeHook,
      checkError = _ref.checkError,
      formValues = _ref.formValues,
      dates = _ref.dates;

  var dateRestrictions = dates(formValues);
  return _react2.default.createElement(
    'div',
    { className: 'applicant-info' },
    _react2.default.createElement(
      _SubSectionHeaderComponent2.default,
      null,
      (0, _translate.t)('Dependent %(index)d', { index: dynamicFieldIndex + 1 })
    ),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'dependentFirstName',
      inputLabel: (0, _translate.t)('First Name'),
      inputComponent: _TextInputComponent2.default,
      inputComponentField: inputComponentField.first_name,
      inputComponentProps: {
        type: 'text',
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.0.additional_data.dependents.' + dynamicFieldIndex + '.first_name')
    }),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'dependentLastName',
      inputLabel: (0, _translate.t)('Last Name'),
      inputComponent: _TextInputComponent2.default,
      inputComponentField: inputComponentField.last_name,
      inputComponentProps: {
        type: 'text',
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.0.additional_data.dependents.' + dynamicFieldIndex + '.last_name')
    }),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'dependentSex',
      inputLabel: (0, _translate.t)('Gender'),
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.sex,
      inputComponentProps: {
        options: formConfig['applicant.additional_data.dependent.sex'].options,
        placeholder: (0, _translate.t)('Please select...'),
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.0.additional_data.dependents.' + dynamicFieldIndex + '.sex')
    }),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'dependentDob',
      inputLabel: (0, _translate.t)('Date of Birth'),
      inputComponent: _DatePickerComponent2.default,
      inputComponentField: inputComponentField.dob,
      inputComponentProps: {
        placeholderText: (0, _translate.t)('Please select a date...'),
        showYearDropdown: true,
        showMonthDropdown: true,
        minDate: dateRestrictions.applicants.dob.min,
        maxDate: dateRestrictions.applicants.dob.max,
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.0.additional_data.dependents.' + dynamicFieldIndex + '.dob')
    }),
    _react2.default.createElement(_LabelledInputComponent2.default, {
      inputId: 'dependentRelationship',
      inputLabel: (0, _translate.t)('Relationship to Applicant'),
      inputComponent: _SelectComponent2.default,
      inputComponentField: inputComponentField.additional_data.relationship_to_applicant,
      inputComponentProps: {
        options: formConfig['applicant.additional_data.dependent.additional_data.relationship_to_applicant'].options,
        placeholder: (0, _translate.t)('Please select...'),
        onChangeHook: onChangeHook
      },
      dynamicFieldIndex: dynamicFieldIndex,
      hasError: checkError('applicant.0.additional_data.dependents.' + dynamicFieldIndex + '.additional_data.relationship_to_applicant')
    })
  );
};

DependentComponent.propTypes = {
  dynamicFieldIndex: _react2.default.PropTypes.number.isRequired,
  inputComponentField: _react2.default.PropTypes.object.isRequired,
  onChangeHook: _react2.default.PropTypes.func,
  checkError: _react2.default.PropTypes.func,
  formValues: _react2.default.PropTypes.object.isRequired,
  dates: _react2.default.PropTypes.func.isRequired,
  formConfig: _react2.default.PropTypes.object
};

exports.default = DependentComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/DependentComponent.jsx
// module id = 1656
// module chunks = 0